import { ImagesMap } from 'core/interfaces/images';

import MAIL from 'src/shared/images/quiz/male.svg';

import FEMAIL from './femail.svg';

import CARD1_1X from './q1/card.webp';
import CARD1_2X from './q1/card@2x.webp';
import CARD1_3X from './q1/card@3x.webp';



import ANSWER1_1_1X from './q1/a1.webp';
import ANSWER1_1_2X from './q1/a1@2x.webp';
import ANSWER1_1_3X from './q1/a1@3x.webp';

import ANSWER1_2_1X from './q1/a2.webp';
import ANSWER1_2_2X from './q1/a2@2x.webp';
import ANSWER1_2_3X from './q1/a2@3x.webp';

import ANSWER1_3_1X from './q1/a3.webp';
import ANSWER1_3_2X from './q1/a3@2x.webp';
import ANSWER1_3_3X from './q1/a3@3x.webp';

import ANSWER1_4_1X from './q1/a4.webp';
import ANSWER1_4_2X from './q1/a4@2x.webp';
import ANSWER1_4_3X from './q1/a4@3x.webp';

import ANSWER1_5_1X from './q1/a5.webp';
import ANSWER1_5_2X from './q1/a5@2x.webp';
import ANSWER1_5_3X from './q1/a5@3x.webp';

import ANSWER1_6_1X from './q1/a6.webp';
import ANSWER1_6_2X from './q1/a6@2x.webp';
import ANSWER1_6_3X from './q1/a6@3x.webp';


export const IMAGES: ImagesMap = {
  FEMALE: {
    src: FEMAIL,
  },
  MALE: {
    src: MAIL,
  },
  CARD1: {
    src: CARD1_1X,
    srcSet: `${CARD1_1X}, ${CARD1_2X} 2x, ${CARD1_3X} 3x`
  },


  //

  ANSWER1_1: {
    src: ANSWER1_1_1X,
    srcSet: `${ANSWER1_1_1X}, ${ANSWER1_1_2X} 2x, ${ANSWER1_1_3X} 3x`
  },
  ANSWER1_2: {
    src: ANSWER1_2_1X,
    srcSet: `${ANSWER1_2_1X}, ${ANSWER1_2_2X} 2x, ${ANSWER1_2_3X} 3x`
  },
  ANSWER1_3: {
    src: ANSWER1_3_1X,
    srcSet: `${ANSWER1_3_1X}, ${ANSWER1_3_2X} 2x, ${ANSWER1_3_3X} 3x`
  },
  ANSWER1_4: {
    src: ANSWER1_4_1X,
    srcSet: `${ANSWER1_4_1X}, ${ANSWER1_4_2X} 2x, ${ANSWER1_4_3X} 3x`
  },
  ANSWER1_5: {
    src: ANSWER1_5_1X,
    srcSet: `${ANSWER1_5_1X}, ${ANSWER1_5_2X} 2x, ${ANSWER1_5_3X} 3x`
  },
  ANSWER1_6: {
    src: ANSWER1_6_1X,
    srcSet: `${ANSWER1_6_1X}, ${ANSWER1_6_2X} 2x, ${ANSWER1_6_3X} 3x`
  },

  ////

};
